module.exports = __webpack_public_path__ + "img/ramsons_washed.58721d0f.jpg";